module.exports = __webpack_public_path__ + "static/img/99.6a789b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/99.png
// module id = 9aKn
// module chunks = 0